import lazyLoadView from './lazyload-view'
import store from '@state/store'
import request from '@utils/request'
import i18n from '@locales/index'

export default [
  // 接待報到
  {
    path: '/check-in',
    name: 'check-in',
    component: () => lazyLoadView(import('@/src/router/views/check-in/index')),
    meta: {
      authRequired: true,
    },
  },
  // 儀表板
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => lazyLoadView(import('@/src/router/views/dashboard/index')),
    meta: {
      authRequired: true,
      title: '儀表板',
      async beforeResolve(routeTo, routeFrom, next) {
        // 檢查是否已經執行過重新載入
        if (!JSON.parse(localStorage.getItem('isReloaded'))) {
          try {
            await store.dispatch('merchant/fetchSingle')
            // 執行畫面重新載入
            localStorage.setItem('isReloaded', 'true')
            localStorage.setItem('version', '20230904-1615')
            window.location.reload()
          } catch (error) {
            next({
              name: '404',
              params: {
                resource: '排班人員',
              },
            })
          }
        } else {
          // 已經執行過重新載入，直接執行 next()
          next()
        }
      },
    },
  },

  // 訂單
  {
    path: '/orders',
    name: 'orders',
    component: () => lazyLoadView(import('@/src/router/views/order/index')),
    meta: {
      title: '訂單管理',
      authRequired: true,
    },
    props: (route) => ({
      productId: route.params.productId,
    }),
  },
  // 會員
  {
    path: '/member',
    name: 'member',
    component: () => lazyLoadView(import('@/src/router/views/member/index')),
    meta: {
      title: '會員管理',
      authRequired: true,
    },
  },
  {
    path: '/member/:memberId',
    name: 'view-member',
    component: () => lazyLoadView(import('@/src/router/views/member/detail')),
    meta: {
      title: '客戶管理',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          .dispatch('member/fetchSingle', { memberId: routeTo.params.memberId })
          .then((member) => {
            routeTo.params.defaultValue = member
            next()
          })
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '客戶',
              },
            })
          })
      },
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
    }),
  },
  // 付款流程
  {
    path: '/merchant/payment/:source/:containerId',
    name: 'PaymentMain',
    component: () => lazyLoadView(import('@/src/router/views/payment/index')),
    props: true,
    meta: {
      title: '付款流程',
      authRequired: true,
    },
  },
  {
    path: '/memberLevel/add',
    name: 'add-memberlevel',
    component: () => lazyLoadView(import('@/src/router/views/member/memberLevel/MemberLevelItemDetailAdd')),
    meta: {
      title: '新增會員等級',
      authRequired: true,
    },
  },
  {
    path: '/memberLevel/:id',
    name: 'view-memberlevel',
    component: () => lazyLoadView(import('@/src/router/views/member/memberLevel/MemberLevelItemDetail')),
    meta: {
      title: '會員等級設定',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([store.dispatch('memberLevel/fetchSingle', routeTo.params.id)])
          .then(
            request.spread((memberLevel) => {
              routeTo.params.defaultValue = {
                ...memberLevel,
                periodType: memberLevel.periodType === 'lifelong' ? 'day' : memberLevel.periodType,
              }
              // routeTo.params.prices = prices
              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '會員等級設定',
              },
            })
          })
      },
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
    }),
  },
  // 折價券
  {
    path: '/coupon',
    name: 'coupon',
    component: () => lazyLoadView(import('@/src/router/views/coupon/list')),
    meta: {
      title: '優惠券',
      authRequired: true,
    },
  },
  {
    path: '/coupon/add',
    name: 'add-coupon',
    component: () => lazyLoadView(import('@/src/router/views/coupon/add')),
    meta: {
      title: '新增優惠券',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([
          store.dispatch('product/fetchList', {
            limit: 10000,
            page: 1,
            paginate: 0,
          }),
          store.dispatch('product/fetchNormalServiceData', {
            types: ['cosmetic'],
            paginate: 0,
          }),
          store.dispatch('product/fetchNormalServiceData', {
            types: ['goods'],
            paginate: 0,
          }),
          //  包月方案暫時用不到，未來會開放 start
          // store.dispatch('prepaid/fetchListAll', { groupByGroupOrdering: 1, paginate: 0 }),
        ])
          .then(
            request.spread((products, prices, goods) => {
              routeTo.params.merchantProducts = products.items
              routeTo.params.prices = prices.items
              routeTo.params.goods = goods.items
              // routeTo.params.prepaids = prepaids.items || []

              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '新增優惠券',
              },
            })
          })
      },
    },
    props: (route) => ({
      products: route.params.merchantProducts,
      prices: route.params.prices,
      goods: route.params.goods,
      prepaids: route.params.prepaids || [],
    }),
  },
  {
    path: '/coupon/:couponId',
    name: 'view-coupon',
    component: () => lazyLoadView(import('@/src/router/views/coupon/detail')),
    meta: {
      title: '優惠券',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([
          store.dispatch('coupon/fetchSingle', routeTo.params.couponId),
          store.dispatch('product/fetchList', {
            limit: 10000,
            page: 1,
            paginate: 0,
          }),
          store.dispatch('product/fetchNormalServiceData', {
            types: ['cosmetic'],
            paginate: 0,
          }),
          store.dispatch('product/fetchNormalServiceData', {
            types: ['goods'],
            paginate: 0,
          }),
          //  包月方案暫時用不到，未來會開放 start
          // store.dispatch('prepaid/fetchListAll', { groupByGroupOrdering: 1, paginate: 0 }),
        ])
          .then(
            request.spread((coupon, products, prices, goods) => {
              routeTo.params.defaultValue = coupon
              routeTo.params.merchantProducts = products.items
              routeTo.params.prices = prices.items
              routeTo.params.goods = goods.items
              // routeTo.params.prepaids = prepaids.items || []

              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '優惠券',
              },
            })
          })
      },
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
      products: route.params.merchantProducts,
      prices: route.params.prices,
      goods: route.params.goods,
      prepaids: route.params.prepaids || [],
    }),
  },
  // 包月方案
  {
    path: '/prepaid',
    name: 'prepaid',
    component: () => lazyLoadView(import('@/src/router/views/prepaid/list')),
    meta: {
      title: `${i18n.messages['zh_TW']['prepaid']['BASE']}方案`,
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([store.dispatch('product/fetchServiceCategory', { paginate: 0 })])
          .then(
            request.spread((category) => {
              routeTo.params.serviceCategory = category
              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: `${i18n.messages['zh_TW']['prepaid']['BASE']}方案`,
              },
            })
          })
      },
    },
    props: (route) => ({
      category: route.params.serviceCategory,
    }),
  },
  {
    path: '/prepaid/add',
    name: 'add-prepaid',
    component: () => lazyLoadView(import('@/src/router/views/prepaid/add')),
    meta: {
      title: `新增${i18n.messages['zh_TW']['prepaid']['BASE']}方案`,
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([
          store.dispatch('product/fetchList', {
            limit: 10000,
            page: 1,
            paginate: 0,
          }),
          store.dispatch('product/fetchServiceCategory', { paginate: 0 }),
          store.dispatch('product/fetchNormalServiceData', { types: ['cosmetic'], paginate: 0 }),
          store.dispatch('mixTag/mixTagSearch', {
            search: '',
            type: 'cosmetic',
            paginate: 0,
          }),
        ])
          .then(
            request.spread((products, category, prices, tags) => {
              routeTo.params.merchantProducts = products.items
              routeTo.params.serviceCategory = category
              routeTo.params.prices = prices.items
              routeTo.params.tagList = tags
              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: `${i18n.messages['zh_TW']['prepaid']['BASE']}方案`,
              },
            })
          })
      },
    },
    props: (route) => ({
      products: route.params.merchantProducts,
      category: route.params.serviceCategory,
      prices: route.params.prices,
      tagList: route.params.tagList,
    }),
  },
  {
    path: '/prepaid/:groupOrdering',
    name: 'view-prepaid',
    component: () => lazyLoadView(import('@/src/router/views/prepaid/detail')),
    meta: {
      title: `${i18n.messages['zh_TW']['prepaid']['BASE']}方案`,
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([
          store.dispatch('product/fetchList', {
            limit: 10000,
            page: 1,
            paginate: 0,
          }),
          store.dispatch('product/fetchServiceCategory', { paginate: 0 }),
          store.dispatch('product/fetchNormalServiceData', { types: ['cosmetic'], paginate: 0 }),
          store.dispatch('prepaid/fetchSingleGroup', routeTo.params.groupOrdering),
          store.dispatch('mixTag/mixTagSearch', {
            search: '',
            type: 'cosmetic',
            paginate: 0,
          }),
        ])
          .then(
            request.spread((products, category, prices, prepaid, tags) => {
              routeTo.params.merchantProducts = products.items
              routeTo.params.serviceCategory = category
              routeTo.params.prices = prices.items
              routeTo.params.defaultValue = prepaid
              routeTo.params.tagList = tags
              next()
            })
          )

          // store
          //   .dispatch('prepaid/fetchSingle', routeTo.params.groupOrdering)
          //   .then((prepaid) => {
          //     // prepaid.prices=[...prepaid.productPrices]
          //     routeTo.params.defaultValue = prepaid
          //     next()
          //   })
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: `${i18n.messages['zh_TW']['prepaid']['BASE']}方案`,
              },
            })
          })
      },
    },
    props: (route) => ({
      products: route.params.merchantProducts,
      category: route.params.serviceCategory,
      prices: route.params.prices,
      defaultValue: route.params.defaultValue,
      tagList: route.params.tagList,
    }),
  },
  // 儲值金
  {
    path: '/deposit',
    name: 'deposit',
    component: () => lazyLoadView(import('@/src/router/views/deposit/index')),
    meta: {
      title: '儲值金方案',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([
          store.dispatch('product/fetchList', {
            limit: 10000,
            page: 1,
            paginate: 0,
          }),
          store.dispatch('product/fetchNormalServiceData', {
            types: ['cosmetic'],
            paginate: 0,
          }),
          store.dispatch('product/fetchNormalServiceData', {
            types: ['goods'],
            paginate: 0,
          }),
          store.dispatch('prepaid/fetchListAll', { groupByGroupOrdering: 1, paginate: 0 }),
        ])
          .then(
            request.spread((products, prices, goods, prepaids) => {
              routeTo.params.merchantProducts = products.items
              routeTo.params.prices = prices.items
              routeTo.params.goods = goods.items
              routeTo.params.prepaids = prepaids.items

              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '儲值金方案',
              },
            })
          })
      },
    },
    props: (route) => ({
      products: route.params.merchantProducts,
      prices: route.params.prices,
      goods: route.params.goods,
      prepaids: route.params.prepaids,
    }),
  },
  {
    path: '/deposit/add',
    name: 'add-deposit',
    component: () => lazyLoadView(import('@/src/router/views/deposit/DepositItemDetail')),
    meta: {
      title: '儲值金方案',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([
          store.dispatch('product/fetchList', {
            limit: 10000,
            page: 1,
            paginate: 0,
          }),
        ])
          .then(
            request.spread((products, category, prices) => {
              routeTo.params.merchantProducts = products.items
              // routeTo.params.serviceCategory = category
              // routeTo.params.prices = prices
              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '儲值金方案',
              },
            })
          })
      },
    },
    props: (route) => ({
      products: route.params.merchantProducts,
      // category: route.params.serviceCategory,
      // prices: route.params.prices,
    }),
  },
  {
    path: '/deposit/:id',
    name: 'view-deposit',
    component: () => lazyLoadView(import('@/src/router/views/deposit/DepositItemDetail')),
    meta: {
      title: '儲值金方案',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([
          store.dispatch('product/fetchList', {
            limit: 10000,
            page: 1,
            paginate: 0,
          }),
          store.dispatch('deposit/fetchSingle', routeTo.params.id),
        ])
          .then(
            request.spread((products, deposit) => {
              routeTo.params.merchantProducts = products.items
              routeTo.params.defaultValue = deposit
              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '儲值金方案',
              },
            })
          })
      },
    },
    props: (route) => ({
      products: route.params.merchantProducts,
      defaultValue: route.params.defaultValue,
    }),
  },

  // 服務項目 prices
  {
    path: '/prices',
    name: 'prices',
    component: () => lazyLoadView(import('@/src/router/views/prices/list')),
    meta: {
      title: '服務項目',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([
          store.dispatch('product/fetchList', {
            limit: 10000,
            page: 1,
          }),
          store.dispatch('product/fetchServiceCategory'),
        ])
          .then(
            request.spread((products, category) => {
              routeTo.params.merchantProducts = products.items
              routeTo.params.serviceCategory = category
              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '服務項目',
              },
            })
          })
      },
    },
    props: (route) => ({
      merchantProducts: route.params.merchantProducts,
      serviceCategory: route.params.serviceCategory,
    }),
  },
  {
    path: '/service',
    name: 'service',
    component: () => lazyLoadView(import('@/src/router/views/prices/list')),
    meta: {
      title: '美容服務',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([
          store.dispatch('product/fetchList', {
            limit: 10000,
            page: 1,
            paginate: 0,
          }),
          store.dispatch('product/fetchServiceCategory', { paginate: 0 }),
        ])
          .then(
            request.spread((products, category) => {
              routeTo.params.merchantProducts = products.items
              routeTo.params.serviceCategory = category
              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '美容服務',
              },
            })
          })
      },
    },
    props: (route) => ({
      merchantProducts: route.params.merchantProducts,
      serviceCategory: route.params.serviceCategory,
    }),
  },
  {
    path: '/hotel',
    name: 'hotel',
    component: () => lazyLoadView(import('@/src/router/views/hotel/index')),
    meta: {
      title: '寵物住宿',
      authRequired: true,
      keepAlive: true,
    },
  },
  {
    path: '/hotel/order/view/:productId/:containerId',
    name: 'hotelViewOrder',
    component: () => lazyLoadView(import('@/src/router/views/schedule/hotel/components/order/hotelViewOrder.vue')),
    props: true,
    meta: {
      title: '住宿訂單詳情',
      authRequired: true,
    },
  },
  {
    path: '/hotel/modify-room/:id',
    name: 'modify-room',
    component: () => lazyLoadView(import('@/src/router/views/hotel/ModifyRoom/index.vue')),
    meta: {
      title: '房型設定',
      authRequired: false,
      keepAlive: true,
    },
  },
  {
    path: '/hotel/room-scheduling/:id',
    name: 'room-scheduling',
    component: () => lazyLoadView(import('@/src/router/views/hotel/RoomScheduling.vue')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: '/hotel/subroom-scheduling/:id',
    name: 'subroom-scheduling',
    component: () => lazyLoadView(import('@/src/router/views/hotel/SubroomScheduling.vue')),
    meta: {
      authRequired: false,
    },
  },
  {
    path: '/goods',
    name: 'goods',
    component: () => lazyLoadView(import('@/src/router/views/commodity/List')),
    meta: {
      title: '商品管理',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([
          store.dispatch('product/fetchList', {
            limit: 10000,
            page: 1,
            paginate: 0,
          }),
          store.dispatch('product/fetchServiceCategory', { paginate: 0 }),
        ])
          .then(
            request.spread((products, category) => {
              routeTo.params.merchantProducts = products.items
              routeTo.params.serviceCategory = category
              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '美容服務',
              },
            })
          })
      },
    },
    props: (route) => ({
      merchantProducts: route.params.merchantProducts,
      serviceCategory: route.params.serviceCategory,
    }),
  },
  // daycare
  {
    path: '/daycare',
    // grooming
    name: 'daycare',
    component: () => lazyLoadView(import('@/src/router/views/daycare/list')),
    meta: {
      title: '安親住宿',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([
          store.dispatch('product/fetchList', {
            limit: 10000,
            page: 1,
          }),
          store.dispatch('product/fetchServiceCategory'),
        ])
          .then(
            request.spread((products, category) => {
              routeTo.params.merchantProducts = products.items
              routeTo.params.serviceCategory = category
              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '安親住宿',
              },
            })
          })
      },
    },
    props: (route) => ({
      merchantProducts: route.params.merchantProducts,
      serviceCategory: route.params.serviceCategory,
    }),
  },
  {
    path: '/service/add/:type?',
    name: 'add-service',
    component: () => lazyLoadView(import('@/src/router/views/prices/ServiceItemDetail')),
    meta: {
      title: '新增服務項目',
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!routeTo.params.merchantProducts) {
          await Promise.all([
            store.dispatch('product/fetchList', {
              limit: 10000,
              page: 1,
              paginate: 0,
            }),
            store.dispatch('product/fetchServiceCategory', { paginate: 0 }),
          ])
            .then(
              request.spread((products, category) => {
                routeTo.params.merchantProducts = products.items
                routeTo.params.serviceCategory = category
                next()
              })
            )
            .catch(() => {
              next({
                name: '404',
                params: {
                  resource: '服務項目',
                },
              })
            })
        } else {
          next()
        }
      },
    },
    props: (route) => ({
      type: route.params.type,
      products: route.params.merchantProducts,
      category: route.params.serviceCategory,
    }),
  },
  {
    path: '/service/edit/:thisServiceId/:type?',
    name: 'view-service',
    component: () => lazyLoadView(import('@/src/router/views/prices/ServiceItemDetail')),
    meta: {
      title: '編輯服務項目',
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        const url = {
          service: 'product/fetchSingleServiceData',
          addition: 'product/fetchSingleServiceData',
          spa: 'product/fetchSingleSpaServiceData',
          daycare: 'product/fetchSingleServiceData',
        }
        await store
          .dispatch(url[routeTo.params.type], routeTo.params.thisServiceId)
          .then((service) => {
            routeTo.params.defaultValue = service
          })
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '服務項目',
              },
            })
          })
        if (!routeTo.params.merchantProducts) {
          await Promise.all([
            store.dispatch('product/fetchList', {
              limit: 10000,
              page: 1,
              paginate: 0,
            }),
            store.dispatch('product/fetchServiceCategory', { paginate: 0 }),
          ])
            .then(
              request.spread((products, category) => {
                routeTo.params.merchantProducts = products.items
                routeTo.params.serviceCategory = category
                next()
              })
            )
            .catch(() => {
              next({
                name: '404',
                params: {
                  resource: '服務項目',
                },
              })
            })
        } else {
          next()
        }
      },
    },
    props: (route) => ({
      type: route.params.type,
      defaultValue: route.params.defaultValue,
      products: route.params.merchantProducts,
      category: route.params.serviceCategory,
    }),
  },
  {
    path: '/goods/add/:type?',
    name: 'add-goods',
    component: () => lazyLoadView(import('@/src/router/views/commodity/ServiceItemDetail')),
    meta: {
      title: '新增服務項目',
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!routeTo.params.merchantProducts) {
          await Promise.all([
            store.dispatch('product/fetchList', {
              limit: 10000,
              page: 1,
              paginate: 0,
            }),
            store.dispatch('product/fetchServiceCategory', { paginate: 0 }),
          ])
            .then(
              request.spread((products, category) => {
                routeTo.params.merchantProducts = products.items
                routeTo.params.serviceCategory = category
                next()
              })
            )
            .catch(() => {
              next({
                name: '404',
                params: {
                  resource: '服務項目',
                },
              })
            })
        } else {
          next()
        }
      },
    },
    props: (route) => ({
      type: route.params.type,
      products: route.params.merchantProducts,
      category: route.params.serviceCategory,
    }),
  },
  // view-goods
  {
    path: '/goods/edit/:thisServiceId/:type?',
    name: 'view-goods',
    component: () => lazyLoadView(import('@/src/router/views/commodity/ServiceItemDetail')),
    meta: {
      title: '編輯商品',
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        console.log('111')
        const url = {
          commodityManage: 'product/fetchSingleServiceData',
        }
        await store
          .dispatch(url[routeTo.params.type], routeTo.params.thisServiceId)
          .then((service) => {
            if (service.petSizes.length > 0) {
              let i = 0
              service.petSizes.forEach((item) => {
                item.noCutArr = []
                item.toFindFilterId = `filterId${i++}`
              })
            }
            routeTo.params.defaultValue = service
          })
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '服務項目',
              },
            })
          })
        if (!routeTo.params.merchantProducts) {
          await Promise.all([
            store.dispatch('product/fetchList', {
              limit: 10000,
              page: 1,
              paginate: 0,
            }),
            store.dispatch('product/fetchServiceCategory', { paginate: 0 }),
          ])
            .then(
              request.spread((products, category) => {
                routeTo.params.merchantProducts = products.items.reduce((accu, cur) => {
                  accu.push({
                    id: cur.id,
                    name: cur.name,
                    storeType: cur.storeType,
                    type: cur.type,
                  })
                  return accu
                }, [])
                routeTo.params.serviceCategory = category
                next()
              })
            )
            .catch(() => {
              next({
                name: '404',
                params: {
                  resource: '服務項目',
                },
              })
            })
        } else {
          next()
        }
      },
    },
    props: (route) => ({
      type: route.params.type,
      defaultValue: route.params.defaultValue,
      products: route.params.merchantProducts,
      category: route.params.serviceCategory,
      serviceId: Number(route.params.thisServiceId),
    }),
  },

  // 排班人員
  {
    path: '/staff',
    name: 'staff',
    component: () => lazyLoadView(import('@/src/router/views/staff/index')),
    meta: {
      title: '人事',
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [staffs, products, fetchUserGroups, fetchUsers] = await Promise.all([
            store.dispatch('schedule/fetchStaff', { paginate: 0 }),
            store.dispatch('product/fetchList', {
              limit: 10000,
              page: 1,
              paginate: 0,
            }),
            store.dispatch('merchant/fetchUserGroups'),
            store.dispatch('merchant/fetchUsers', {
              paginate: 0,
            }),
          ])
          await store.dispatch('merchant/fetchSingle')
          routeTo.params.staffItems = staffs
          routeTo.params.merchantProducts = products.items
          routeTo.params.userRecords = fetchUsers.records
          routeTo.params.userGroups = fetchUserGroups
          next()
        } catch (error) {
          next({
            name: '404',
            params: {
              resource: '排班人員',
            },
          })
        }
      },
    },
    props: (route) => ({
      fetchUserGroups: route.params.fetchUserGroups || [],
      staffItems: route.params.staffItems || [],
      merchantProducts: route.params.merchantProducts || [],
      userActiveTab: route.params.userActiveTab || '',
      userActiveId: route.params.id || '',
      userRecords: route.params.userRecords || 10,
    }),
  },
  // 數據分析
  {
    path: '/analytics',
    name: 'analytics',
    component: () => lazyLoadView(import('@/src/router/views/analytics/index')),
    meta: {
      title: '數據分析',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([
          store.dispatch('product/fetchList', {
            limit: 10000,
            page: 1,
            paginate: 0,
          }),
          store.dispatch('product/fetchServiceCategory', { paginate: 0 }),
        ])
          .then(
            request.spread((products, category) => {
              routeTo.params.merchantProducts = products.items
              routeTo.params.serviceCategory = category
              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '數據分析',
              },
            })
          })
      },
    },
    props: (route) => ({
      merchantProducts: route.params.merchantProducts,
      serviceCategory: route.params.serviceCategory,
    }),
  },
  // 分店
  {
    path: '/products',
    name: 'products',
    component: () => lazyLoadView(import('@/src/router/views/product/list')),
    meta: {
      authRequired: true,
      title: '分店設定',
    },
  },
  {
    path: '/products/:productId?/add',
    name: 'add-product',
    component: () => lazyLoadView(import('@/src/router/views/product/add')),
    meta: {
      title: '新增分店',
      authRequired: true,
      async beforeResolve(routeTo, _, next) {
        const productId = routeTo.params.productId

        if (productId) {
          try {
            const matchedProduct = await store.dispatch('product/fetchSingle', productId)
            // routeTo.params.defaultStep = matchedProduct.activeStep
            routeTo.params.defaultStep = 3
            routeTo.params.product = matchedProduct
            next()
          } catch (error) {
            next({
              name: '404',
              params: {
                resource: '商品',
              },
            })
          }
        } else {
          next()
        }
      },
    },
    props: (route) => ({
      // defaultStep:3,
      defaultStep: route.params.defaultStep || 1,
      defaultValue: route.params.product,
      productType: (route.params.product && route.params.product.type) || route.query.type,
    }),
  },
  {
    path: '/products/:productId/edit',
    name: 'edit-product',
    component: () => lazyLoadView(import('@/src/router/views/product/edit')),
    meta: {
      title: '編輯分店',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          .dispatch('product/fetchSingle', routeTo.params.productId)
          .then((product) => {
            routeTo.params.product = product
            next()
          })
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '商品',
              },
            })
          })
      },
    },
    props: (route) => ({
      defaultValue: route.params.product,
      productType: route.params.product.type,
    }),
  },

  // 管理帳號
  {
    path: '/account',
    name: 'account',
    meta: {
      title: '管理帳號',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([store.dispatch('merchant/fetchUsers')], [store.dispatch('merchant/fetchUserGroups')], [store.dispatch('product/fetchList')])
          .then(() => next())
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '商店管理帳號',
              },
            })
          })
      },
    },
    component: () => lazyLoadView(import('@/src/router/views/admin/list')),
  },
  // 訊息回覆
  {
    path: '/chat',
    name: 'chat',
    component: () => lazyLoadView(import('@/src/router/views/chat/list')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/chat/:memberId',
    name: 'view-chat',
    component: () => lazyLoadView(import('@/src/router/views/chat/detail')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('member/updateActiveChatMemberId', routeTo.params.memberId)
        store
          .dispatch('member/fetchSingle', { memberId: routeTo.params.memberId })
          .then((member) => {
            routeTo.params.defaultValue = member
            next()
          })
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '訊息回覆',
              },
            })
          })
      },
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
    }),
  },
  // 商家設定
  {
    path: '/settings',
    name: 'settings',
    meta: {
      title: '商店設定',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        Promise.all([store.dispatch('merchant/fetchSingle')])
          .then(() => next())
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '商家設定',
              },
            })
          })
      },
    },
    component: () => lazyLoadView(import('@/src/router/views/settings/index')),
  },

  // 接待報到
  {
    path: '/schedule-check-in',
    name: 'schedule-check-in',
    component: () => lazyLoadView(import('@/src/router/views/schedule/check-in')),
    meta: {
      title: '櫃檯管理',
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const sameRoute =
          routeFrom.name === 'schedule-check-in' &&
          routeTo.name === 'schedule-check-in' &&
          routeFrom.path === routeTo.path &&
          JSON.stringify(routeFrom.query || {}) === JSON.stringify(routeTo.query || {}) &&
          routeFrom.hash !== routeTo.hash
        if (sameRoute) {
          routeTo.params.staffItems = routeFrom.params.staffItems
          routeTo.params.merchantProducts = routeFrom.params.merchantProducts
          next()
          return
        }
        Promise.all([
          store.dispatch('schedule/fetchStaff', { paginate: 0 }),
          store.dispatch('product/fetchList', {
            limit: 10000,
            page: 1,
            paginate: 0,
          }),
          store.dispatch('merchant/fetchSingle'),
        ])
          .then(
            request.spread((staffs, products) => {
              routeTo.params.staffItems = staffs
              routeTo.params.merchantProducts = products.items
              next()
            })
          )
          .catch(() => {
            next({
              name: '404',
              params: {
                resource: '前台接待',
              },
            })
          })
      },
    },
    props: (route) => ({
      staffItems: route.params.staffItems,
      merchantProducts: route.params.merchantProducts,
    }),
  },

  // ==== 美容師專屬介面 START ==== //
  {
    path: '/employee-booking',
    name: 'employee-booking',
    component: () => lazyLoadView(import('@/src/router/views/employee/booking')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        next()
      },
    },
  },
  {
    path: '/employee-calendar',
    name: 'employee-calendar',
    component: () => lazyLoadView(import('@/src/router/views/employee/calendar')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        next()
      },
    },
  },
  {
    path: '/employee-check-in',
    name: 'employee-check-in',
    component: () => lazyLoadView(import('@/src/router/views/employee/check-in')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        next()
      },
    },
  },
  {
    path: '/employee-staff',
    name: 'employee-staff',
    component: () => lazyLoadView(import('@/src/router/views/employee/staff')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('merchant/fetchUserGroups').then((res) => {
          routeTo.params.userGroups = res
        })
        next()
      },
    },
  },
  // ==== 美容師專屬介面 END ==== //
]
